import { atom } from 'jotai';

// 用户激活状态 Atom
export const userActivationStatusAtom = atom<
  'pending' | 'activated' | 'failed'
>('pending');

// 用户信息 Atom
export const userInfoAtom = atom<{ id: string; email: string } | null>(null);

// 用户登录状态 Atom
export const userLoggedInAtom = atom<boolean>(false);

// 组合状态 Atom
export const userStateAtom = atom((get) => ({
  activationStatus: get(userActivationStatusAtom),
  userInfo: get(userInfoAtom),
  isLoggedIn: get(userLoggedInAtom),
}));

export const isMobileAtom = atom<boolean>(false);
